<div
  class="flex flex-col rounded-(--sectionedexpandablecard-border-radius) gap-(--sectionedexpandablecard-gap) px-(--sectionedexpandablecard-padding-x) py-(--sectionedexpandablecard-padding-y) w-full"
  [style.background]="containerBackground()"
  [style.border]="borderStyle()"
  [class.shadow-(--shadow-base)]="config().dropShadow"
>
  @for (section of displayedSections(); track $index) {
    <div class="flex flex-col gap-(--sectionedexpandablecard-section-gap)">
      <app-dynamic
        componentName="Chip"
        [props]="{ config: section.chip }"
      />
      <app-dynamic
        componentName="DynamicText"
        [props]="sectionTextPropsMap()[$index]"
      />
    </div>
  }

  @if (config().sections.length > 1) {
    <div class="self-start">
      <app-dynamic
        componentName="Button"
        [props]="buttonProps()"
        (action)="toggle()"
      />
    </div>
  }
</div>
